<template>
  <div
    v-if="text !== 'AC'"
    id="crumbs"
    @mouseenter="openPresetMenu"
    @mouseleave="closePresetMenu"
  >
    <!--    <div class="btn-group btn-group-sm" role="group" aria-label="First group">-->
    <button
      v-if="text !== 'TR'"
      type="button"
      class="btn btn-tr "
      :class="{
        'btn-tr-agent': auth.user.role === 7,
        'opts-btn-height':
          text == 'FN +1' ||
          text == 'FN +2' ||
          text == 'FN +3' ||
          text == 'FN +4' ||
          text == 'FN +5' ||
          text == 'FN +6' ||
          text == 'FN +7' ||
          text == 'FN +8'
      }"
      @click="
        text === 'Today'
          ? $emit('today')
          : text === 'yesterday'
          ? $emit('yesterday')
          : text === 'Last Month'
          ? $emit('lastMonth')
          : text === 'this Month'
          ? $emit('thisMonth')
          : text === 'Last 7'
          ? $emit('last7days')
          : text === 'Last 30'
          ? $emit('last30days')
          : text === 'Last 90'
          ? $emit('last90days')
          : text === 'Last 180'
          ? $emit('last180days')
          : text === 'All'
          ? $emit('All')
          : ''
      "
    >
      <!--      <span v-if="text == 'FN'"> {{ text }}</span>-->
      <span v-if="text === 'DUP'" style="margin-left: 5px"><i class="fas fa-bars"></i></span>
      <span> {{ text }}&nbsp;{{ stats == 0 ? " " : kFormatter(stats) }}</span>

      <!--      <span-->
      <!--              class="reset-btn"-->
      <!--              v-if="resetBtn.tr && resetTrButtons"-->
      <!--              @click.stop="closeResetBtn('tr')"-->
      <!--      ><i class="fas fa-times"></i>-->
      <!--        </span>-->
      <div class="bb-title-wrapper upper-title">
        <span class="tra" v-if="text === 'TR'">Tra</span>
        <span class="tra" v-if="text === 'FN'">Func</span>
      </div>
      <!--        {{ stats == 0 ? text : kFormatter(stats)}}-->
    </button>
    <!--    </div>-->

    <button
      v-if="text === 'TR'"
      type="button"
      class="btn btn-tr"
      @mouseenter="openSubWSecond('tr')"
      @mouseleave="closeSubWSecond('tr')"
    >
      <!--      @click="openSubW('regular', 'tr')"-->

      <!--      :class="{-->
      <!--      'btn-tr-agent': auth.user.role === 7,-->
      <!--      'greyed-out':-->
      <!--      selectedMainTab === 'bn' || greyOutTag('tr', selectedMainTab)-->
      <!--      }"-->
      <span>{{ stats == 0 ? "TR" : kFormatter(stats) }}</span>

      <div class="bb-sub-menu" v-if="checkSubMenuMode('tr')">
        <div
          class="bb-sub-menu-ms"
          @click.stop="openMsW('tr')"
          v-tooltip="{ content: `Open multi-select` }"
        >
          <div class="tr-color bb-item">
            <i class="fas fa-bars"></i>
          </div>
          <div class="fake-column tr-color"></div>
        </div>
        <div
          class="bb-sub-menu-reset"
          @click.stop="closeResetBtnW('tr')"
          v-tooltip="{ content: `Reset` }"
        >
          <div class="tr-color bb-item">
            <i class="fas fa-times"></i>
          </div>
          <div class="fake-column tr-color"></div>
        </div>
      </div>
      <div class="bb-sub-menu" v-if="checkIfSecondView('tr')">
        <div
          v-if="checkNumbersOfCalendarsSelected() === 1"
          class="bb-sub-menu-ms"
          @click.stop="mergeAllDates('tr', 'regular', shortCutsToBlocks)"
          v-tooltip="{
            content: `Use the same selected dates with this new selection`
          }"
        >
          <!--          @click.stop="filterMultipleTags('regular', 'ld')"-->

          <div class="tr-color bb-item">
            <div class="first-circle-tot"></div>
            <div class="second-circle-tot"></div>
            <div class="fake-column-tot tr-color"></div>
          </div>
        </div>
        <div
          class="bb-sub-menu-reset"
          @click.stop="filterSingleTag('regular', 'tr')"
          v-tooltip="{ content: `Disregard previous selections` }"
        >
          <div class="tr-color bb-item">
            <div class="first-circle first-circle-right"></div>
            <div class="second-circle second-circle-right"></div>
          </div>
          <div class="fake-column tr-color"></div>
        </div>
        <div
          class="bb-sub-menu-ms"
          @click.stop="filterMultipleTags('regular', 'tr')"
          v-tooltip="{ content: `Productivity` }"
        >
          <div class="tr-color bb-item">
            <div class="first-circle"></div>
            <div class="second-circle "></div>
            <div class="fake-column tr-color"></div>
          </div>
        </div>
      </div>
      <div class="bb-title-wrapper upper-title">
        <span class="tra" v-if="text === 'TR'">Tra</span>
        <span class="tra" v-if="text === 'FN'">Func</span>
      </div>
      <div
        class="tags-dropdown"
        v-if="
          text === 'TR' &&
            openTagDropdown &&
            mouseOver &&
            !checkSubMenuMode('tr') &&
            !checkIfSecondView('tr')
        "
      >
        <!--        <div class="tags-dropdown" v-if="false">-->
        <TagsDropdown
          :btnColors="btnColors"
          @presetTrigger="emitPresetTrigger"
        />
      </div>
    </button>
    <!--    <a-->
    <!--      class="table-main-tag"-->
    <!--      @click="-->
    <!--        text === 'Today'-->
    <!--          ? $emit('today')-->
    <!--          : text === 'yesterday'-->
    <!--          ? $emit('yesterday')-->
    <!--          : text === 'Last Month'-->
    <!--          ? $emit('lastMonth')-->
    <!--          : text === 'this Month'-->
    <!--          ? $emit('thisMonth')-->
    <!--          : text === 'Last 7'-->
    <!--          ? $emit('last7days')-->
    <!--          : text === 'Last 30'-->
    <!--          ? $emit('last30days')-->
    <!--          : text === 'Last 90'-->
    <!--          ? $emit('last90days')-->
    <!--          : text === 'Last 180'-->
    <!--          ? $emit('last180days')-->
    <!--          : text === 'All'-->
    <!--          ? $emit('All')-->
    <!--          : ''-->
    <!--      "-->
    <!--      :style="btnStyles"-->
    <!--      href="javascript:void(0);"-->
    <!--      >{{ text }} <span v-if="!totalDisable">{{ kFormatter(stats) }}</span></a-->
    <!--    >-->
  </div>
  <div v-else id="crumbsTR">
    <div class="btn-group btn-group-sm" role="group" aria-label="First group">
      <button
        type="button"
        class="btn btn-tr"
        @click="
          text === 'Today'
            ? $emit('today')
            : text === 'yesterday'
            ? $emit('yesterday')
            : text === 'Last Month'
            ? $emit('lastMonth')
            : text === 'this Month'
            ? $emit('thisMonth')
            : text === 'Last 7'
            ? $emit('last7days')
            : text === 'Last 30'
            ? $emit('last30days')
            : text === 'Last 90'
            ? $emit('last90days')
            : text === 'Last 180'
            ? $emit('last180days')
            : text === 'All'
            ? $emit('All')
            : ''
        "
      >
        <span v-if="text == 'FN'"> {{ text }}</span>
        <span class="for-min-height">{{
          stats == 0 ? text : kFormatter(stats)
        }}</span>
      </button>
    </div>

    <!--    <a-->
    <!--      class="table-main-tag"-->
    <!--      @click="-->
    <!--        text === 'Today'-->
    <!--          ? $emit('today')-->
    <!--          : text === 'yesterday'-->
    <!--          ? $emit('yesterday')-->
    <!--          : text === 'Last Month'-->
    <!--          ? $emit('lastMonth')-->
    <!--          : text === 'this Month'-->
    <!--          ? $emit('thisMonth')-->
    <!--          : text === 'Last 7'-->
    <!--          ? $emit('last7days')-->
    <!--          : text === 'Last 30'-->
    <!--          ? $emit('last30days')-->
    <!--          : text === 'Last 90'-->
    <!--          ? $emit('last90days')-->
    <!--          : text === 'Last 180'-->
    <!--          ? $emit('last180days')-->
    <!--          : text === 'All'-->
    <!--          ? $emit('All')-->
    <!--          : ''-->
    <!--      "-->
    <!--      :style="btnStyles"-->
    <!--      href="javascript:void(0);"-->
    <!--      >{{ text }} <span v-if="!totalDisable">{{ kFormatter(stats) }}</span></a-->
    <!--    >-->
  </div>

  <!--  <div id="crumbs">
        <a :style="btnStyles" href="javascript:void(0);"
        >{{ text }} <span v-if="stats !==0">{{ kFormatter(stats)}} </span> <span class="progress-spinner" v-else> <md-progress-spinner :md-diameter="15" :md-stroke="2" md-mode="indeterminate"></md-progress-spinner></span></a>

      </div>-->
</template>

<script>
import breadButtonsFunctionsUtil from "../../mixins/breadButtonsFunctionsUtil";
import UsersPermissionCheck from "../../../../../../mixins/user/auth/UsersPermissionCheck";
import { mapState } from "vuex";
import calendarCheck from "../../../../../../mixins/tags/calendarCheck";
import TagsDropdown from "./TagsDropdown.component";
import { Globals } from "../../../../../../global_constants/constants";

export default {
  name: "BreadcrumbButton",
  mixins: [UsersPermissionCheck, breadButtonsFunctionsUtil, calendarCheck],
  components: {
    TagsDropdown
  },
  props: {
    ifCalendarSelected: {
      type: Object
    },
    selectedMainTab: {
      type: String,
      required: true
    },
    secondActiveTagsArr: {
      type: Array
    },
    activeTags: {
      type: Array
    },
    resetTrButtons: {
      type: Boolean
    },
    statsRegPreset: {
      type: Object
    },
    variant: {
      type: String,
      required: false
    },
    bgColor: {
      type: String,
      required: true
    },
    txtColor: {
      type: String,
      required: true
    },
    totalText: {
      type: Number,
      required: false
    },
    text: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false
    },
    lastModDisable: {
      type: Boolean,
      required: false
    },
    disableSpinner: {
      type: Boolean,
      required: false,
      default: () => false
    },
    stats: {
      type: Number,
      required: false
    },
    totalDisable: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  data() {
    return {
      calendarForPreset: "TRA",
      mouseOver: false,
      btnColors: {
        backgroundColor: "#cab717",
        color: "white"
      },
      openTagDropdown: false,
      showPopup: false,
      resetBtn: {
        tr: false,
        fn: false
      },
      totalSum: ""
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", [
      "totalSumForCrumbBtn",
      "shortCutsToBlocks"
    ]),
    btnStyles() {
      return {
        "--bg-color":
          this.disabled || this.totalDisable ? "#546e7a" : this.bgColor,
        "--hover-on-disable":
          this.disabled || this.totalDisable ? "-3px" : "0px",
        "--cursor-on-total-disable": !this.totalDisable ? "pointer" : "default",
        "--font-weight": this.disabled ? "bold" : "normal",
        "--txt-color": this.txtColor,
        "--border-color": this.variant === "outlined" ? "#546e7a" : this.bgColor
      };
    }
  },
  watch: {
    totalSumForCrumbBtn: function() {
      this.totalSum = this.totalSumForCrumbBtn;
    }
  },
  methods: {
    closePresetMenu() {
      this.openTagDropdown = false;
      this.mouseOver = false;
    },
    openPresetMenu() {
      this.mouseOver = true;
      setTimeout(() => {
        if (this.mouseOver) {
          this.openTagDropdown = true;
        }
      }, Globals.ux.section.top_tag_menu.cal_presets_speed);
    },
    emitPresetTrigger(preset) {
      if (preset !== "ALL") {
        this.triggerPreset(this.calendarForPreset, preset);
      }
      if (preset) {
        this.openSubW("regular", "tr");
      }
    },
    kFormatter: function(num) {
      if (num) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
          : Math.sign(num) * Math.abs(num);
      }
      /*      if(num===0){
                            return 0
                          }*/
    }
  }
};
</script>

<style lang="scss" scoped>
$color: var(--bg-color);
$borderColor: var(--border-color);
$btnBgColor: #cab717;
$hoverColor: #546e7a;
$fontWeight: var(--font-weight);
.tag-wrapper {
  display: inline;
  position: relative;
}

#crumbs {
  position: relative;
  /*margin-right: 10px;*/
}

/*#crumbs a {
          position:absolute;
          display: block;
          float: left;
          height: 20px;
          width: 65px;//70px;
          line-height: 16pt;
          background: $color;
          padding: 0 3px 0 4px;
          border-color: $borderColor ;
          position: relative;
          margin: 0 20px 0 0;
          text-align: center;
          text-decoration: none;
          color: var(--txt-color);
          font-size:8pt; //9pt;
          font-family: "Segoe UI", Arial, sans-serif;
          font-weight: bold; !*$fontWeight;*!
          border-bottom-left-radius: 3px;
          border-top-left-radius: 3px;
          top: var(--hover-on-disable);
        }

        #crumbs a:after {
          content: "";
          border-top: 10px solid ;
          border-bottom: 10px solid transparent;
          border-left: 10px solid $color;
          position: absolute;
          right: -10px;
          top: 0;


        }*/
.floating-wrapper:last-child #crumbs a {
  width: initial; //70px;
}

#crumbs a {
  display: block;
  float: left;
  height: 20px;
  width: 70px; //70px;
  line-height: 16pt;
  background: #ab9b0c;
  padding: 0 3px 0 4px;
  border-color: $borderColor;
  position: relative;
  margin: 0px 20px 0 0;
  text-align: center;
  text-decoration: none;
  color: var(--txt-color);
  font-size: 12px; //9pt;
  font-family: "Montserrat", Montserrat, serif;
  font-weight: 500;
  /*$fontWeight;*/
  /*border-bottom-left-radius: 5px;*/
  /*border-bottom-right-radius: 5px;*/
  /*border-top-left-radius: 5px;*/
  top: var(--hover-on-disable);
  cursor: var(--cursor-on-total-disable);
}

#crumbsTR a {
  display: block;
  float: left;
  height: 20px;
  /*width: 75px; //70px;*/
  line-height: 16pt;
  background: #008b00;
  padding: 0 3px 0 4px;
  border-color: $borderColor;
  position: relative;
  margin: 0px 20px 0 0;
  text-align: center;
  text-decoration: none;
  color: var(--txt-color);
  font-size: 12px; //9pt;
  font-family: "Montserrat", Montserrat, serif;
  font-weight: 500;

  /*$fontWeight;*/
  /*border-bottom-left-radius: 5px;*/
  /*border-bottom-right-radius: 5px;*/
  /*border-top-left-radius: 5px;*/
  top: var(--hover-on-disable);
  cursor: var(--cursor-on-total-disable);
}

#crumbs a:hover {
  /* background: $hoverColor;*/
  top: -3px;
}

/*#crumbs a:hover::after {
          content: "";
          border-top: 10px solid transparent;
          border-bottom: 10px solid transparent;
          border-left: 10px solid $color;
          position: absolute;
          top: 0px;
          //top: 0;
        }*/

.tag-table {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 10001;
  width: max-content;
  background-color: #fff;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.table-responsive {
  margin-bottom: -18px;
  border-radius: 5px;
}

.dot-right {
  height: 26px;
  width: 26px;
  color: #009147;
  /*border-radius: 50%;*/
  bottom: 11px;
  right: -7px;
  position: absolute;
  font-weight: 500;
  font-size: 12px;
}

.dot-left {
  height: 26px;
  width: 26px;
  background-color: $color;
  border-radius: 50%;
  bottom: 8px;
  left: -8px;
  position: absolute;
  font-weight: 500;
  font-size: 12px;
}

.progress-spinner {
  margin-bottom: -5px;
}

.btn-tr {
  font-size: 10px;
  color: #ffffff;
  background-color: #cab717;
  //border-color: #827717;
  transition: all 0.2s ease-in;
  width: 100%;
  border-radius: 5px !important;
  /*max-width: 61px;*/
  /*margin-right: 10px;*/
}

.btn-tr-agent {
  /*max-width: 80px;*/
}

.btn-tr {
  color: #ffffff;
  background-color: #cab717;
  //border-color: #827717;
  outline: none;
  font-weight: 900;
  position: relative;
}

.btn-tr:hover,
.btn-tr:focus,
.btn-tr:active,
.btn-tr.active .open .dropdown-toggle.btn-tr {
  color: #ffffff;
  background-color: #cab717;
  //border-color: #827717;
  outline: none;
  z-index: 0 !important;
}

.btn-tr:hover {
  outline: none;
  z-index: 1 !important;
}

.floating-process-switcher #crumbs {
  margin: 6px;
}

.floating-process-switcher #crumbs .btn-group-sm {
  width: 100%;
}

.floating-process-switcher #crumbs .btn-group-sm .btn-tr {
  width: 108%;
}

.btn-tr:hover {
  transform: scale(1.1);
  //cursor: default;
}

/*.btn-tr:hover div.bb-title-wrapper{*/
/*  width: 85%;*/
/*}*/
div.bb-title-wrapper {
  //position: absolute;
  color: white;
  font-size: 8px;
  width: 85%;
  top: 28px;
  left: 5px;
  text-align: center;
  transition: width 0.2s ease-in;
}

.reset-btn {
  position: absolute;
  top: -8px;
  right: 0px;
  color: #333;
  transition: all 0.2s ease-in;
}

.reset-btn:hover {
  position: absolute;
  transform: scale(1.3);
  color: red;
  top: -6px;
  right: 4px;
}

.upper-title {
  text-transform: uppercase;
}

.bb-sub-menu-reset {
  /*margin-right: 10px;*/
}

.first-circle {
  background-color: white;
  height: 10px;
  width: 10px;
  position: absolute;
  border-radius: 50%;
  left: 2px;
  top: 8px;
}

.second-circle {
  background-color: white;
  height: 8px;
  width: 8px;
  position: absolute;
  border-radius: 50%;
  left: 8px;
  top: 3px;
}

.first-circle-right {
  /*left: 45px;*/
  background-color: white;
}

.second-circle-right {
  /*left: 50px;*/
  background-color: inherit;
  border: 1px solid white;
}

.tr-color {
  background-color: $btnBgColor;
}

.bb-sub-menu {
  position: absolute;
  width: 100%;
  top: -26px;
  left: 0px;
  display: flex;
  justify-content: space-between;
  height: 30px;
  cursor: pointer;
}

.bb-sub-menu-reset,
.bb-sub-menu-ms {
  /*padding: 3px 5px;*/
  /*<!--background-color: $btnColor;-->*/
  border-radius: 4px;
  height: 30px;
  width: 20px;
}

.bb-item {
  height: 20px;
  width: 20px;
  border-radius: 5px;
  padding-top: 3px;
  position: relative;
}

.fake-column {
  width: 8px;
  height: 10px;
  margin-left: 6px;
}

div.second-circle + div.fake-column {
  margin-top: 14px;
}

.greyed-out {
  opacity: 0.5;
  pointer-events: none;
}

.first-circle-tot {
  background-color: inherit;
  height: 10px;
  width: 10px;
  position: absolute;
  border-radius: 50%;
  left: 2px;
  top: 8px;
  border: 1px solid white;
}

.second-circle-tot {
  border: 1px solid white;
  background-color: inherit;
  height: 8px;
  width: 8px;
  position: absolute;
  border-radius: 50%;
  left: 8px;
  top: 3px;
}

.fake-column-tot {
  width: 8px;
  /*height: 10px;*/
  height: 23px;
  margin-left: 6px;
}

.tags-dropdown {
  /*padding: 3px 5px;*/
  position: absolute;
  /*background-color: wheat;*/
  top: 38px;
  left: 0px;
  z-index: 1;
  border-radius: 5px;
  width: 100%;
}

.tra {
  padding-left: 8px;
}

.opts-btn-height {
  min-height: 39px !important;
}
</style>
